import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-awaiting-confirmation',
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: './awaiting-confirmation.component.html',
  styleUrl: './awaiting-confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwaitingConfirmationComponent {}
